import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import GameItemSupportBonus from "../mui/game_tem/GameItemSupportBonus";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino";
import { useDispatch } from "react-redux";
import { setProvidersGamesById } from "../../store/gamesSlice.js";

export default function Provider() {
  const dispatch = useDispatch();
  const { subId } = useParams();
  const providers = useAppSelector((state) => state.games.providers);
  const providerId = providers.find((el) => el.name == subId)?.id;
  const games = useAppSelector((state) => state.games.providersGamesById[providerId]);

  console.log("providerId", providerId);

  useEffect(() => {
    if (!providerId) return;

    API_CASINO.list
      .providerGames({ providerId })
      .then((e) => {
        const list = e.data.list;
        dispatch(setProvidersGamesById({ id: providerId, data: list }));
      })
      .catch(console.error);
  }, [providerId]);

  return (
    <div className="games__games">
      {games?.map((el) => (
        <GameItemSupportBonus currentGame={el} key={el.game_id} name={el.name} image={el.image} />
      ))}
    </div>
  );
}
